console.log("AI Recommendation Engine Loaded");


//================================================
// MAIN AI RECOMMENDATION ENGINE
//================================================

function recommendProductsByRequirement(message){

    //----------------------------------------
    // UNDERSTAND CUSTOMER REQUEST
    //----------------------------------------

    const family =
        detectRequestedFamily(message);

    const requirement =
        getPrimaryRequirement(message);

    const requestedLocation =
        detectRequestedLocation(message);

    const features =
        detectRequestedFeatures(message);

    const budget =
        detectBudget(message);


    console.log("Family :", family);
    console.log("Requirement :", requirement);
    console.log("Requested Location :", requestedLocation);
    console.log("Features :", features);
    console.log("Budget :", budget);


    //----------------------------------------
    // START WITH ALL PRODUCTS
    //----------------------------------------

    let products = ALL_PRODUCTS;


    //----------------------------------------
    // FAMILY FILTER
    //----------------------------------------

    if(family){

        products = products.filter(product =>

            detectProductFamily(product) === family

        );

        console.log(
            "After Family Filter:",
            products.length
        );

    }


    //----------------------------------------
    // LOCATION FILTER
    //----------------------------------------

    if(requestedLocation){

        products = filterProductsByLocation(
            products,
            requestedLocation
        );

        console.log(
            "After Location Filter:",
            products.length
        );

    }


    //----------------------------------------
    // SUBTYPE FILTER
    //----------------------------------------

    if(
        family === "CCTV" &&
        requirement
    ){

        const preferred =
            getPreferredSubtypes(requirement);


        console.log(
            "Preferred Subtypes:",
            preferred
        );


        if(preferred.length){

            products = products.filter(product =>

                preferred.includes(
                    detectCCTVSubtype(product)
                )

            );


            console.log(
                "After Subtype Filter:",
                products.length
            );

        }

    }


    //----------------------------------------
    // FEATURE FILTER
    //----------------------------------------

    if(
        features &&
        features.length
    ){

        products = filterProductsByFeatures(
            products,
            features
        );


        console.log(
            "After Feature Filter:",
            products.length
        );

    }


    //----------------------------------------
    // BUDGET FILTER
    //----------------------------------------

    if(budget){

        products = filterProductsByBudget(
            products,
            budget
        );


        console.log(
            "After Budget Filter:",
            products.length
        );

    }


//----------------------------------------
// EXACT MATCH FOUND
//----------------------------------------

if(products.length > 0){

    console.log(
        "Recommended Products :",
        products.length
    );


    //----------------------------------------
    // CLEAR OLD ALTERNATIVE STATE
    //----------------------------------------

    window.AI_ALTERNATIVE_DATA = {

        active: false,

        originalMessage: message,

        family: family,

        requirement: requirement,

        location: requestedLocation,

        features: features,

        budget: budget,

        products: []

    };


    return products;

}


    //================================================
    // NO EXACT MATCH
    // FIND SMART ALTERNATIVES
    //================================================

    console.log(
        "No exact match found. Searching alternatives..."
    );


    //----------------------------------------
    // START ALTERNATIVE SEARCH
    //----------------------------------------

    let alternativeCandidates =
        ALL_PRODUCTS;


    //----------------------------------------
    // FAMILY FILTER
    //----------------------------------------

    if(family){

        alternativeCandidates =
            alternativeCandidates.filter(product =>

                detectProductFamily(product) === family

            );

    }


    console.log(
        "Alternative Family Products:",
        alternativeCandidates.length
    );


    //----------------------------------------
    // LOCATION FILTER
    //----------------------------------------

    if(requestedLocation){

        alternativeCandidates =
            filterProductsByLocation(
                alternativeCandidates,
                requestedLocation
            );

    }


    console.log(
        "Alternative Location Products:",
        alternativeCandidates.length
    );


    //----------------------------------------
    // FIND ALTERNATIVES
    //----------------------------------------

    let alternatives = [];


    if(
        typeof findAlternativeProducts === "function"
    ){

        alternatives =
            findAlternativeProducts(
                alternativeCandidates,
                features,
                budget
            );

    }


    console.log(
        "Alternative Products:",
        alternatives.length
    );


    //----------------------------------------
    // SAVE ALTERNATIVE INFORMATION
    // FOR THE MAIN CHAT ENGINE
    //----------------------------------------

    window.AI_ALTERNATIVE_DATA = {

        active: alternatives.length > 0,

        originalMessage: message,

        family: family,

        requirement: requirement,

        location: requestedLocation,

        features: features,

        budget: budget,

        products: alternatives

    };


    //----------------------------------------
    // ALTERNATIVES FOUND
    //----------------------------------------

    if(alternatives.length > 0){

        console.log(
            "Smart Alternatives Found:",
            alternatives
        );


        //------------------------------------
        // RETURN ALTERNATIVES
        //------------------------------------

        return alternatives;

    }


    //----------------------------------------
    // NOTHING FOUND
    //----------------------------------------

    console.log(
        "No exact products or alternatives found."
    );


    window.AI_ALTERNATIVE_DATA = {

        active: false,

        originalMessage: message,

        family: family,

        requirement: requirement,

        location: requestedLocation,

        features: features,

        budget: budget,

        products: []

    };


    return [];

}



//================================================
// DETECT REQUESTED PRODUCT FAMILY
//================================================
//================================================
// DETECT REQUESTED PRODUCT FAMILY
//================================================

function detectRequestedFamily(message){

    message = message.toLowerCase().trim();


    //----------------------------------------
    // HIDDEN / SPY CAMERA
    // IMPORTANT: THIS MUST COME FIRST
    //----------------------------------------

    if(
        message.includes("spy") ||
        message.includes("hidden") ||
        message.includes("secret camera") ||
        message.includes("mini spy") ||
        message.includes("spy cam") ||
        message.includes("spy camera") ||
        message.includes("pen camera") ||
        message.includes("camera pen") ||
        message.includes("eyeglass camera") ||
        message.includes("glasses camera") ||
        message.includes("wearable camera") ||
        message.includes("body camera") ||
        message.includes("discreet camera") ||
        message.includes("discrete camera") ||
        message.includes("covert camera")
    ){

        return "HIDDEN_CAMERA";

    }


    //----------------------------------------
    // FINGERPRINT LOCK
    //----------------------------------------

    if(
        message.includes("fingerprint") ||
        message.includes("lock")
    ){

        return "FINGERPRINT_LOCK";

    }


    //----------------------------------------
    // GPS
    //----------------------------------------

    if(
        message.includes("gps")
    ){

        return "GPS";

    }


    //----------------------------------------
    // VIDEO DOORBELL
    //----------------------------------------

    if(
        message.includes("doorbell")
    ){

        return "VIDEO_DOORBELL";

    }


    //----------------------------------------
    // CCTV
    // KEEP THIS AFTER HIDDEN CAMERA
    //----------------------------------------

    if(
        message.includes("camera") ||
        message.includes("cctv") ||
        message.includes("security camera")
    ){

        return "CCTV";

    }


    //----------------------------------------
    // NO FAMILY DETECTED
    //----------------------------------------

    return null;

}